import './App.css';

import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

import Login from './login';
import Dashboard from './dashboard';
import Appointments from './appointments';
import PatientDetails from './details';
import Register from './register';
import Book from './book';
import Logout from './logout';

function App() {

    return (
            <Router basename={process.env.REACT_APP_PATH}>
                <Switch>
                    <Route path="/home">
                        <Dashboard />
                    </Route>
                    <Route path="/appointments">
                        <Appointments />
                    </Route>
                    <Route path="/book">
                        <Book />
                    </Route>
                    <Route path="/details">
                        <PatientDetails />
                    </Route>
                    <Route path="/register">
                        <Register />
                    </Route>
                    <Route path="/logout">
                        <Logout />
                    </Route>
                    <Route path="/">
                        <Login />
                    </Route>
                </Switch>
            </Router>
    );
}

export default App;
